var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-textarea',{staticStyle:{"font-family":"monospace, monospace"},attrs:{"label":"Code"},model:{value:(_vm.node.code),callback:function ($$v) {_vm.$set(_vm.node, "code", $$v)},expression:"node.code"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }